import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AaliBuilders = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.2 });
    document.querySelectorAll('.scroll-reveal, .service-item, .info-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="company-hero" style={{ background: 'linear-gradient(135deg, #1e40af, #2563eb)' }}>
        <div className="hero-content">
          <h1>AALI BUILDERS</h1>
          <p>Premier infrastructure development company building world-class residential and commercial projects</p>
        </div>
      </div>
      <div className="company-content">
        <div className="container">
          <div className="company-grid">
            <div className="left scroll-reveal">
              <h2>About AALI BUILDERS</h2>
              <p>AALI BUILDERS is committed to creating sustainable infrastructure that shapes communities and drives economic growth. Our portfolio includes landmark commercial complexes, residential townships, and urban development projects.</p>
              <h3>Our Services</h3>
              <div className="services-list">
                <div className="service-item"><span>✔</span> Commercial Development</div>
                <div className="service-item"><span>✔</span> Residential Projects</div>
                <div className="service-item"><span>✔</span> Urban Planning</div>
                <div className="service-item"><span>✔</span> Smart City Solutions</div>
                <div className="service-item"><span>✔</span> Infrastructure Modernization</div>
              </div>
            </div>
            <div className="info-card scroll-reveal">
              <h4>Company Info</h4>
              <div className="info-block">
                <span className="info-label">Industry</span>
                <strong className="info-value">Infrastructure</strong>
              </div>
              <div className="info-block">
                <span className="info-label">Parent Company</span>
                <strong className="info-value">AALI GROUP</strong>
              </div>
              <div className="actions">
                <Link to="/contact" className="btn-primary">Get in Touch</Link>
                <a href="https://aalibuilders.com/" className="btn-primary" target="_blank" rel="noopener noreferrer">
                  Visit Main Website
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AaliBuilders;